import "../styles/main.scss";
import "./plugins";

$(document).ready(() => {
  // jquery ready
  console.log("ready");
});
